import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompanyService } from '../_services';
import * as CompanyActions from '../_actions/company';

@Injectable({
  providedIn: 'root',
})
export class CompanyEffects {
  loadCompanies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.loadCompanies),
      mergeMap(() =>
        this.companyService.getCompanies().pipe(
          map((companies) => CompanyActions.loadCompaniesSuccess({ companies })),
          catchError((error) => of(CompanyActions.loadCompaniesFailure({ error })))
        )
      )
    )
  );

  addCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.addCompany),
      mergeMap(({ company }) =>
        this.companyService.saveCompany(company).pipe(
          map((savedCompany) => CompanyActions.addCompanySuccess({ company: savedCompany })),
          catchError((error) => of(CompanyActions.addCompanyFailure({ error })))
        )
      )
    )
  );

  updateCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.updateCompany),
      mergeMap(({ company }) =>
        this.companyService.saveCompany(company).pipe(
          map((updatedCompany) => CompanyActions.updateCompanySuccess({ company: updatedCompany })),
          catchError((error) => of(CompanyActions.updateCompanyFailure({ error })))
        )
      )
    )
  );

  deleteCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.deleteCompany),
      mergeMap(({ id }) =>
        this.companyService.deleteCompany(id).pipe(
          map(() => CompanyActions.deleteCompanySuccess({ id })),
          catchError((error) => of(CompanyActions.deleteCompanyFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private companyService: CompanyService
  ) {}
}
